import type { PointerEvent } from 'react';

/**
 * Pointer light for clickable cards (`fx-spot`): sets --mx / --my where the pointer is, so a soft glow follows it.
 * Cheap (two CSS variables, no re-render); does nothing for touch.
 */
export function spot(e: PointerEvent<HTMLElement>) {
  if (e.pointerType === 'touch') return;
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty('--mx', `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty('--my', `${e.clientY - r.top}px`);
}
